import { LoadingButton } from "@mui/lab";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";

interface Props {
  open: boolean;
  name: string;
  loading: boolean;
  onNameChange: (value: string) => void;
  onClose: () => void;
  onConfirm: () => void;
}

export default function SaveAsNewTemplateDialog({
  open,
  name,
  loading,
  onNameChange,
  onClose,
  onConfirm,
}: Props) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Save as New Template</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          label="Template name"
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") onConfirm();
          }}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <LoadingButton
          loading={loading}
          variant="contained"
          disableElevation
          onClick={onConfirm}
        >
          Save
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
